import {DefaultEntitiesRef, EntitiesRef, EntitiesState, getEntityType} from "@ngneat/elf-entities";
import {Query} from "@ngneat/elf";

/*
* getManyByPredicate ser ikke ut til å være korrekt eksportert i "@ngneat/elf-entities"@4.6.0
* - importen: `import {getManyByPredicate} from "@ngneat/elf-entities";` feiler.
* Har derfor lagt til en --nesten-- uendret kopi av impl fra
* https://github.com/ngneat/elf/blob/c7800beb22bc81810e9019684ab0ba39474d25db/packages/entities/src/lib/queries.ts
* @todo se om denne kan slettes når neste ver av elf-entities er tilgjengelig
*/
export function getManyByPredicate<
  S extends EntitiesState<Ref>,
  R extends getEntityType<S, Ref>[],
  K extends keyof getEntityType<S, Ref>,
  Ref extends EntitiesRef = DefaultEntitiesRef
>(
  predicate: any): Query<S, getEntityType<S, Ref>[]> {
    return function (state) {
        //const { ref: { entitiesKey, idsKey } = defaultEntitiesRef, pluck } = options || {};
        const entitiesKey = 'entities';
        const idsKey = 'ids';

        const filteredEntities: getEntityType<S, Ref>[] = [];
        state[idsKey].forEach((id: any, index: number) => {
            const entity = state[entitiesKey][id];

            if (predicate(entity, index)) {
                filteredEntities.push(entity);
            }
        });

        return filteredEntities;
    };
}


/*
//UENDRET IMPL:
export function getManyByPredicate<
  S extends EntitiesState<Ref>,
  R extends getEntityType<S, Ref>[],
  K extends keyof getEntityType<S, Ref>,
  Ref extends EntitiesRef = DefaultEntitiesRef
>(
  predicate: ItemPredicate<getEntityType<S, Ref>>,
  options?: {
      pluck?: K | ((entity: getEntityType<S, Ref>) => R);
  } & BaseEntityOptions<Ref>
): Query<S, getEntityType<S, Ref>[]> {
    return function (state) {
        const { ref: { entitiesKey, idsKey } = defaultEntitiesRef, pluck } =
        options || {};
        const filteredEntities: getEntityType<S, Ref>[] = [];

        state[idsKey].forEach((id: getIdType<S, Ref>, index: number) => {
            const entity = state[entitiesKey][id];

            if (predicate(entity, index)) {
                filteredEntities.push(checkPluck(entity, pluck));
            }
        });

        return filteredEntities;
    };
}
*/
